import { ReactNode } from 'react'
import cx from 'classnames'
import { GlassSurface, Text } from '~m/designSystem'
import styles from './SyncSourceHeader.module.css'

export interface SyncSourceHeaderProps {
  /** The integration's name, used for the accessible label */
  integrationName: string
  /**
   * The integration's logo, shown on the left. Pass the full
   * lockup (mark and name) as the integration styles it.
   */
  integrationLogo: ReactNode
  /** Icon between the two logos, e.g. a two-way arrow */
  syncIcon?: ReactNode
  /** Short explanation shown under the logos */
  description?: ReactNode
  /** Additional CSS class */
  className?: string
}

/**
 * Sits above the list of reconciliation rows and names the one
 * integration the sync is with: its logo on the left and the
 * Soniq Studio logo on the right. Because the header names the
 * source, the rows don't repeat it.
 */
export function SyncSourceHeader({
  integrationName,
  integrationLogo,
  syncIcon,
  description,
  className,
}: SyncSourceHeaderProps) {
  return (
    <GlassSurface
      variant="panel"
      className={cx(styles.SyncSourceHeader, className)}
    >
      <div
        className={styles.SyncSourceHeader__logos}
        role="img"
        aria-label={`${integrationName} syncing with Soniq Studio`}
      >
        <span className={styles.SyncSourceHeader__logo}>
          {integrationLogo}
        </span>
        {syncIcon && (
          <span className={styles.SyncSourceHeader__sync}>
            {syncIcon}
          </span>
        )}
        <span
          className={cx(
            styles.SyncSourceHeader__logo,
            styles.SyncSourceHeader__soniq
          )}
        >
          <img src="/soniq-favicon.svg" alt="" />
          <span>Soniq Studio</span>
        </span>
      </div>
      {description && (
        <Text variant="date" component="p">
          {description}
        </Text>
      )}
    </GlassSurface>
  )
}
